<template>
    <div class="miniMpContent MiniParlaySlip_view">
        <div class="miniMpContent-odds">
            <div class="sm_contentBox">
                <MediumParlayTicket
                    v-for="(ticket, key) in betSlip.tickets"
                    v-bind:key="key"
                    v-bind:subBet="ticket"
                    v-on:refreshTicket="refresh(false)"
                />
                <div
                    v-if="!isValidSubBetCount"
                    class="sm_add MiniParlaySlip_Img_AddOneMoreBet"
                    v-on:click="collapseBetSlipForAddMoreBet"
                >
                    <p>
                        <ParlayTicketCountInsufficientMessage />
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { defineComponent } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import MediumParlayTicket from '@/components/betSlip/MediumParlayTicket.vue';
    import ParlayTicketCountInsufficientMessage from '@/components/betSlip/ParlayTicketCountInsufficientMessage.vue';
    import { RoutePage } from '@/interface/enum';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useParlayBetSlipStore } from '@/stores/betSlip/parlayBetSlipStore';

    export default defineComponent({
        name: 'MediumParlayBetSlipContent',
        components: {
            ParlayTicketCountInsufficientMessage,
            MediumParlayTicket,
        },
        setup() {
            const { showMiniBetSlip } = useBetSlipStore();

            const {
                betSlip,
                isValidSubBetCount,
            } = storeToRefs(useParlayBetSlipStore());

            const router = useRouter();
            const route = useRoute();
            function collapseBetSlipForAddMoreBet() {
                showMiniBetSlip();
                if (route.name !== RoutePage.Main && route.name !== RoutePage.MainBySport) {
                    router.push({ name: RoutePage.Main });
                }
            }

            const { refresh } = useParlayBetSlipStore();

            return {
                refresh,
                betSlip,
                isValidSubBetCount,
                collapseBetSlipForAddMoreBet,
            };
        },
    });
</script>

<style lang="scss">
    @import "@/scss/components/miniMpTicketContent";
</style>
